import { render, staticRenderFns } from "./SpecialtyInformation.vue?vue&type=template&id=d45480d6"
import script from "./SpecialtyInformation.vue?vue&type=script&lang=js"
export * from "./SpecialtyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45480d6')) {
      api.createRecord('d45480d6', component.options)
    } else {
      api.reload('d45480d6', component.options)
    }
    module.hot.accept("./SpecialtyInformation.vue?vue&type=template&id=d45480d6", function () {
      api.rerender('d45480d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/practitionerIntern/components/SpecialtyInformation/SpecialtyInformation.vue"
export default component.exports